import GameModel from "../model/GameModel";
import SlotServerManager from "Engine/slots/server/SlotServerManager";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import Relax from "./Relax";
import EntryPoint from "../../../../engine/src/EntryPoint";

export default class ServerManager extends SlotServerManager {
    constructor() {
        super();
    }

    addDataProvider() {
        this.dataProvider = new Relax();
    }

    addListeners() {
        GlobalDispatcher.add('rollingState:start', this.onStartSpin, this);
        //GlobalDispatcher.add('model:init', this.onInit, this);
        GlobalDispatcher.add('realityCheck:continue', this.onRealityCheckContinue, this);
        GlobalDispatcher.add('request:getBalance', this.onGetBalance, this);
        GlobalDispatcher.add('request:ping', this.onPing, this);
        GlobalDispatcher.add('request:gamefinished', this.onGameFinished, this);
        GlobalDispatcher.add('dataProvider:hasResponse', this.onResponse, this);

        GlobalDispatcher.add('preloaderController:loadingPreloaderComplete', this.loadingPreloaderComplete, this);
    }

    loadingPreloaderComplete() {
        this.dataProvider.init();
        this.onInit();
    }

    onInit() {
        let request = {
            action: 'init'
        };
        this.dataProvider.action(request);
    }

    onStartSpin() {
        let request = {
            bet: GameModel.bet,
            lines: GameModel.lines,
            action: 'spin'
        };
        this.dataProvider.action(request);
    }

    onRealityCheckContinue() {
        let request = {
            action: 'resetrealitycheck'
        };
        this.dataProvider.action(request);
    }

    onGameFinished() {
        let request = {
            action: 'gamefinished'
        };
        this.dataProvider.action(request);
    }

    onGetBalance() {
        let request = {
            action: 'getBalance'
        };
        this.dataProvider.action(request);
    }

    onPing() {
        let request = {
            action: 'ping'
        };
        this.dataProvider.action(request);
    }

    onResponse(data) {
        //console.log('onResponse', data.params.action);
        switch (data.params.action) {
            case 'init':
            case 'reconnect':
                this.hasInitData(data.params);
                break;
            case 'spin':
            case 'freeSpin':
                this.hasSpinData(data.params);
                break;
            case 'ping':
            case 'getBalance':
                const {params: {balance}} = data.params;
                GameModel.balance = balance;
                EntryPoint.PostMessages && EntryPoint.PostMessages.onBalanceUpdate()
                break;
        }
    }

    hasInitData(data) {
        GameModel.setNewData(data);
    }

    hasSpinData(data) {
        //console.log('hasSpinData');
        GameModel.setNewData(data);
    }
}
